import Students from 'modules/Students/index'
import { connect } from 'react-redux'

import instSelector from 'modules/Students/selectors'

import { getPreview } from 'modules/ATS/action'
import {
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
} from 'modules/JobPreview/action'
import {
  SelectBlacklist,
  SelectOptOutlist,
  SelectUnRestricted,
  activeInactivateStatus,
  blacklistStudent,
  bulkReInviteStudent,
  bulkUploadStudents,
  createStudent,
  deleteBulkStudents,
  deleteStudent,
  editStudent,
  getConsentDrawerList,
  getDegreeData,
  getNotificationCatalogues,
  getSingleStudentData,
  getStudentsListData,
  getStudentsListResume,
  reInviteStudent,
  sendNotificationEmail,
  studentsMetricsData,
} from 'modules/Students/actions'
import selectors from '../../Auth/selectors'
import { resumeBulkDownload } from '../../Placement/action'

const mapStateToProps = state => ({
  instituteCampusId: state.auth.instituteDetails.id,
  studentsList: instSelector.getStudentsList(state),
  singleStudentData: instSelector.getSingleStudentData(state),
  studentsMetrics: instSelector.getStudentMetricsData(state),
  degreeList: instSelector.getStudentDegreeList(state),
  permissions: selectors.getUserPermissions(state),
  notificationCatalogues: instSelector.getNotificationCatalogueData(state),
})

const mapDispatchToProps = {
  getStudentsListData,
  createStudent,
  getSingleStudentData,
  deleteStudent,
  editStudent,
  studentsMetricsData,
  blacklistStudent,
  activeInactivateStatus,
  deleteBulkStudents,
  reInviteStudent,
  getDegreeData,
  bulkUploadStudents,
  getNotificationCatalogues,
  sendNotificationEmail,
  SelectUnRestricted,
  getConsentDrawerList,
  SelectBlacklist,
  SelectOptOutlist,
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
  getPreview,
  bulkReInviteStudent,
  getStudentsListResume,
  resumeBulkDownload,
}

export default connect(mapStateToProps, mapDispatchToProps)(Students)
